<template>
    <!--
        The design's login: one centred 400px card, no title band. The sign-in logic is
        unchanged - the same fields, checks, messages and remember-me.
    -->
    <div class="auth">
        <div class="auth-card">
            <div class="auth-head">
                <h1 class="auth-title">{{ $lang.Login.Heading }}</h1>
                <p class="auth-subtitle">{{ $lang.Login.Subtitle }}</p>
            </div>

            <div v-if="hasError_signIn" class="auth-error">{{ warning_signIn }}</div>

            <div class="auth-fields">
                <b-field :label="$lang.Login.EmailLabel" :type="{ 'is-danger': hasError_email || hasError_signIn }" :message="emptyWarning_email">
                    <b-input type="email"
                             v-model="email"
                             placeholder="ad@firma.com"
                             required>
                    </b-input>
                </b-field>

                <b-field :label="$lang.Login.Password" :type="{ 'is-danger': hasError_password || hasError_signIn }" :message="emptyWarning_password">
                    <password-input v-model="password" required></password-input>
                </b-field>
            </div>

            <div class="login-row">
                <b-checkbox v-model="rememberMe">{{ $lang.Login.RememberMe }}</b-checkbox>
                <a href="#" @click.prevent="forgetPassword()">{{ $lang.Login.ForgetPassword }}</a>
            </div>

            <b-button class="auth-submit" type="is-primary" expanded @click="signIn()">
                {{ $lang.Login.Heading }}
            </b-button>

            <div class="login-or">
                <span></span>{{ $lang.Login.Or }}<span></span>
            </div>

            <div class="login-signup">
                <span>{{ $lang.Login.NoAccount }}</span>
                <b-button class="auth-secondary" expanded @click="openSignUpPage()">
                    {{ $lang.Member.AddNew }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import PasswordInput from '@/components/PasswordInput.vue';

    export default {
        name: 'ProjectInfos',
        components: { PasswordInput },
        data() {
            return {
                isActive: true,
                rememberMe: false,
                canSignIn: false,
                hasError_email: false,
                emptyWarning_email: '',
                hasError_password: false,
                emptyWarning_password: '',
                hasError_signIn: false,
                warning_signIn: '',
                email: '',
                password: ''
            }
        },
        mounted() {
            this.$store.state.isFooterFixed = true;
        },
        destroyed() {
            this.$store.state.isFooterFixed = false;
        },
        methods: {
            openSignUpPage() {
                this.$store.state.currentRoute = this.$route.name;
                router.push('/addMember');
            },
            signIn() {
                if (this.email == '') {
                    this.hasError_email = true;
                    this.emptyWarning_email = this.$lang.Menus.EmptyWarning;
                } else if (this.password == '') {
                    this.hasError_password = true;
                    this.emptyWarning_password = this.$lang.Menus.EmptyWarning;
                } else {
                    this.canSignIn = true;

                    // "Beni Hatırla" is a month's token instead of a working day's; nothing
                    // password-like is kept in the browser (docs/16-api-authorization.md).
                    api.members.login(this.email, this.password, this.rememberMe).then((res) => {
                        if (res.isError && res.unauthorized) {
                            this.hasError_signIn = true;
                            this.warning_signIn = this.$lang.Login.ErrorMsg;
                            return;
                        }
                        if (res.isError) {
                            this.$buefy.dialog.alert(this.$errorModal(res));
                            return;
                        }
                        this.hasError_signIn = false;
                        this.emptyWarning_password = '';
                        this.$store.commit('signedIn', { member: res.data.Member, token: res.data.Token, expiresAt: res.data.ExpiresAt, rememberMe: this.rememberMe });

                        if (this.$store.canResultOpen) {
                            router.push('/results');
                        } else {
                            router.push('/');
                        }
                    });
                }

                if (this.email != '') {
                    this.hasError_email = false;
                    this.emptyWarning_email = '';
                }
                if (this.password != '') {
                    this.hasError_password = false;
                    this.emptyWarning_password = '';
                }
            },
            forgetPassword() {
                router.push('/passwordEmail');
            }
        }
    };
</script>

<style lang="scss">
    /* The card itself is in scss/_auth-card.scss, shared with the password screens. */
    .login-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        font-size: 14px;
    }

    .login-or {
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 12px;
        color: #6b6b6b;

        span {
            flex: 1;
            height: 1px;
            background: #e3e3e3;
        }
    }

    .login-signup {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        color: #575757;
    }
</style>
